import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch } from 'react-instantsearch';

import SearchField from '../../header/search/search-box';
import CareersResults from './careers-results';

import './index.css';

const searchClient = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_SEARCH_KEY);

const SiteSearch = ({ mobileSearch }) => {
	const appendEnv = process.env.GATSBY_CONTENTSTACK_ENVIRONMENT !== 'production' ? '-dev' : '';
	const searchRef = useRef(null);
	const [activeSearch, setActiveSearch] = useState(false);

	const indices = [
		{
			name: `Careers${appendEnv}`,
			title: `Careers`,
			hitComp: `NoImageHitLink`,
		},
	];

	useEffect(() => {
		document.addEventListener('mousedown', onOutsideClick);
		document.addEventListener('touchstart', onOutsideClick);

		return () => {
			document.removeEventListener('mousedown', onOutsideClick);
			document.removeEventListener('touchstart', onOutsideClick);
		};
	}, []);

	const onOutsideClick = (e) => {
		if (e.target && searchRef?.current && !searchRef.current.contains(e.target)) {
			setActiveSearch(false);
		}
	};

	const onSearchFocus = () => setActiveSearch(true);

	return (
		<InstantSearch
			indexName={indices[0].name}
			searchClient={searchClient}
			future={{ preserveSharedStateOnUnmount: true }}
		>
			<div
				ref={searchRef}
				className={mobileSearch ? 'bottom-full left-5 right-5 z-[15] block max-h-[calc(100vh-85px)] overflow-auto bg-white max-sm:absolute max-sm:border-2 max-sm:border-primary max-sm:p-5 max-sm:shadow-lg sm:static sm:overflow-hidden sm:max-lg:mx-4 sm:max-lg:max-h-none lg:absolute lg:bottom-auto lg:top-full lg:overflow-auto lg:max-2xl:border-2 lg:max-2xl:border-primary lg:max-2xl:p-4 lg:max-2xl:shadow-lg lg:max-xl:p-6 2xl:static' : 'hidden sm:block sm:px-4 md:px-0 lg:hidden 2xl:block 2xl:overflow-hidden'}
			>
				<div
					aria-label='Search products, advice'
					className='careersSearch sm:relative 2xl:w-[285px]'
				>
					<SearchField
						onFocus={onSearchFocus}
						aria-label='Search careers...'
						placeholder='Search careers...'
						className='w-full max-w-full flex-1 border border-black bg-white py-1 pl-7 pr-5 text-base [&+span]:!left-2 [&+span]:!text-lg [&~button>span]:scale-75 [&~button]:!right-1'
						showSearchIcon
						showReset
					/>
				</div>

				{activeSearch && <CareersResults indices={indices} />}
			</div>
		</InstantSearch>
	);
};

SiteSearch.propTypes = {
	indices: PropTypes.array,
	mobileSearch: PropTypes.bool,
};

export default SiteSearch;
